import { inject, Injectable, Provider } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);

    if (title !== undefined) {
      this.title.setTitle(`${title} | toibox by Classi`);
    } else {
      this.title.setTitle(`toibox by Classi`);
    }
  }
}

export function provideTitleStrategy(): Provider[] {
  return [
    {
      provide: TitleStrategy,
      useClass: AppTitleStrategy,
    },
  ];
}
